<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account-multiple"
          :title="$route.params.id ? $t('Edit Person') : $t('New Person')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.first_name"
                  :label="$t('first_name')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="first_name"
                  :error-messages="errors.collect('first_name')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.last_name"
                  :label="$t('last_name')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="last_name"
                  :error-messages="errors.collect('last_name')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.address"
                  :label="$t('address')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="address"
                  :error-messages="errors.collect('address')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.plz"
                  :label="$t('plz')"
                  autocomplete="new-password"
                  v-validate=""
                  required
                  data-vv-name="plz"
                  :error-messages="errors.collect('plz')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.place"
                  :label="$t('place')"
                  autocomplete="new-password"
                  v-validate=""
                  required
                  data-vv-name="place"
                  :error-messages="errors.collect('place')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.tax"
                  :label="$t('tax')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="tax"
                  :error-messages="errors.collect('tax')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="formValues.gender"
                  :items="genders"
                  item-text="name"
                  item-value="id"
                  :label="$t('gender')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="gender"
                  :error-messages="errors.collect('gender')"
                >
                </v-select>
              </v-col>
              <v-col>
                <base-date-picker
                  v-model="formValues.birth"
                  :label="$t('birth')"
                  :errors="errors.collect('birth')"
                ></base-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.phone"
                  :label="$t('phone')"
                  autocomplete="new-password"
                  v-validate=""
                  required
                  data-vv-name="phone"
                  :error-messages="errors.collect('phone')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.email"
                  :label="$t('email')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="email"
                  :error-messages="errors.collect('email')"
                  :readonly="!edit"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="formValues.lang"
                  :items="languages"
                  item-text="name"
                  item-value="id"
                  :label="$t('language')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="lang"
                  :error-messages="errors.collect('lang')"
                >
                </v-select>
              </v-col>
            </v-row>
            <template v-if="formValues.childrens">
              <v-row>
                <v-col>
                  <v-card color="grey lighten-2">
                    <v-card-text>
                      <p>
                        <strong>{{ $t("Children") }}: </strong>
                        <template
                          v-for="(child, index) in formValues.childrens"
                        >
                          <span v-if="index > 0" :key="'_' + index">, </span>
                          <a
                            @click="
                              $router.push({ path: '/be/child/' + child.id })
                            "
                            :key="index"
                            >{{ child.first_name }}
                            {{ child.last_name }}
                          </a>
                        </template>
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <v-card-actions class="pl-0">
              <v-btn
                class="mr-4"
                @click="$router.push({ name: 'person.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                class="mr-2"
                @click="showItem(formValues)"
              >
                {{ $t("detail") }}
              </v-btn>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
export default {
  name: "app-person-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {},
      permissions: [],
      loading: true,
      genders: [
        {
          id: "m",
          name: this.$t("men")
        },
        {
          id: "f",
          name: this.$t("woman")
        },
        {
          id: "s",
          name: this.$t("divers")
        }
      ],
      languages: [
        {
          id: "de",
          name: this.$t("de")
        },
        {
          id: "it",
          name: this.$t("it")
        }
      ],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      if (this.$route.name === "person.show") {
        this.edit = false;
      } else {
        this.edit = true;
      }
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.formValues.parent = true;
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "person.index" });
      }
    },
    showItem(item) {
      let url = item.id;
      this.$router.push({
        name: "person.show",
        params: { id: url }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
